export default {
  PING: `/ping`,
  CONVERT: '/convert'
}